import { Link } from "react-router-dom";
import { Instagram, Lock } from "lucide-react";
import { INFO } from "@/data/site";
import { usePublicHours } from "@/data/usePublicHours";
import { useLang } from "@/i18n";

const TikTok = (props) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" {...props}>
    <path d="M16.5 3c.3 2.3 1.9 4 4.2 4.3v2.7c-1.5.1-2.9-.4-4.2-1.2v6.1c0 3.4-2.6 6.1-6 6.1s-6-2.7-6-6.1c0-3.3 2.6-6 5.8-6 .3 0 .6 0 .9.1v2.9c-.3-.1-.6-.2-.9-.2-1.7 0-3 1.4-3 3.2 0 1.8 1.3 3.2 3 3.2s3.1-1.4 3.1-3.2V3h3.1z" />
  </svg>
);

export const Footer = () => {
  const { t } = useLang();
  const HOURS = usePublicHours();
  return (
  <footer data-testid="site-footer" className="bg-primary text-primary-foreground">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-20">
      <div className="grid gap-14 md:grid-cols-4">
        <div className="md:col-span-2">
          <img src="/logo-light.png" alt="Maschas Atelier" className="h-9 w-auto mb-6" />
          <p className="text-primary-foreground/70 max-w-sm leading-relaxed">
            {t("hero.tagline")}
          </p>
          <div className="flex gap-4 mt-8">
            <a data-testid="footer-instagram" href={INFO.instagram} target="_blank" rel="noreferrer"
               className="w-11 h-11 border border-primary-foreground/30 flex items-center justify-center transition-colors duration-300 hover:bg-primary-foreground hover:text-primary">
              <Instagram strokeWidth={1.25} size={20} />
            </a>
            <a data-testid="footer-tiktok" href={INFO.tiktok} target="_blank" rel="noreferrer"
               className="w-11 h-11 border border-primary-foreground/30 flex items-center justify-center transition-colors duration-300 hover:bg-primary-foreground hover:text-primary">
              <TikTok />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] mb-5 text-primary-foreground/60">{t("footer.hours")}</h4>
          <ul className="space-y-2 text-sm">
            {HOURS.map((h) => (
              <li key={h.day} className="flex justify-between gap-4 text-primary-foreground/80">
                <span>{h.dayKey ? t(h.dayKey) : h.day}</span><span>{h.closedKey ? t(h.closedKey) : h.time}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] mb-5 text-primary-foreground/60">{t("footer.contact")}</h4>
          <p className="text-sm text-primary-foreground/80 leading-relaxed">
            {INFO.address}<br />
            <a href={`mailto:${INFO.email}`} className="hover:underline">{INFO.email}</a><br />
            <a data-testid="footer-phone" href={`tel:${INFO.phone}`} className="hover:underline">0176 45665753</a>
          </p>
          <div className="flex flex-col gap-2 mt-5 text-sm">
            <Link to="/kontakt" className="hover:underline">{t("nav.kontakt")}</Link>
            <Link to="/buchung" className="hover:underline">{t("nav.buchen_cta")}</Link>
            <Link to="/impressum" data-testid="footer-impressum-link" className="hover:underline">Impressum</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:underline">Datenschutz</Link>
            <Link to="/agb" data-testid="footer-agb-link" className="hover:underline">AGB</Link>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-primary-foreground/20 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-primary-foreground/50">
        <span>© {new Date().getFullYear()} Maschas Atelier · Studio &amp; Academy</span>
        <span className="flex items-center gap-3">
          Löhrstraße 1 · 56068 Koblenz
          <Link to="/kalender" data-testid="footer-admin-link" title="Interner Bereich" aria-label="Interner Bereich" className="text-primary-foreground/30 hover:text-primary-foreground transition-colors duration-300">
            <Lock size={13} strokeWidth={1.5} />
          </Link>
        </span>
      </div>
    </div>
  </footer>
  );
};
